import vuetify from "@/plugins/vuetify";
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const vuei18n = new VueI18n({
    silentFallbackWarn: true, // Suppress warnings
    locale: "en",
    fallbackLocale: "en",
    messages: {},
});

export default vuei18n;

export async function changeLocale(lang) {
    if (lang) {
        const path = `${process.env.BASE_URL}assets/language/${lang}.json?version=${process.env.VERSION}`;
        console.debug("downloading lang file:", path);

        const res = await axios.get(path);
        vuei18n.setLocaleMessage(lang, res.data);
        vuei18n.locale = lang;
        moment.locale(lang);
        vuetify.framework.lang.current = lang;
    }
}
